// react
import styled from 'styled-components';

// components
import { Icon, Card } from '@/components/atoms';
import { Icons } from '@/components/atoms/Icon';

/**
 * CallDetails renders the card with the details of the call.
 */
export const CallDetails = ({ callData }: CallDetailsProps) => {
  return (
    <Card key='card-content' color='blue' isBordered={false}>
      <ContentTitle>Call details</ContentTitle>
      <Content>
        <StyledTable>
          {callData?.map(
            (row) =>
              row.data !== '' && (
                <StyledRow key={row.id}>
                  <td>
                    <IconWrapper>
                      <StyledIcon icon={row.icon as Icons} fontSize={22} />
                      <Title>{row.title}</Title>
                    </IconWrapper>
                  </td>
                  <td>
                    <DataText>{row.data}</DataText>
                  </td>
                </StyledRow>
              ),
          )}
        </StyledTable>
      </Content>
    </Card>
  );
};

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  color: ${(props) => props.theme.color.primary[80]};
  width: 24px;
  margin-right: ${(props) => props.theme.spacing[16]};
`;

const Title = styled.div`
  color: ${(props) => props.theme.color.neutral[90]};
  font: ${(props) => props.theme.typography.heading['1xl']};
  font-weight: 600;
`;

const DataText = styled.div`
  color: ${(props) => props.theme.color.neutral[80]};
  font: ${(props) => props.theme.typography.body.md};
`;

const StyledTable = styled.table`
  display: flex;
  flex-direction: column;
`;

const StyledRow = styled.tr`
  padding-bottom: ${(props) => props.theme.spacing[8]};
`;

const LinkWrapper = styled.div`
  display: flex;
`;

const Content = styled.div`
  font: ${(props) => props.theme.typography.body.md.regular};
  color: ${(props) => props.theme.color.neutral[90]};
`;

const ContentTitle = styled.div`
  font: ${(props) => props.theme.typography.heading['2xl']};
  margin-bottom: ${(props) => props.theme.spacing[12]};
  color: ${(props) => props.theme.color.neutral[90]};
`;

export interface CallDetailItem {
  id: string;
  icon: string;
  title: string;
  data: string;
}
interface CallDetailsProps {
  callData: CallDetailItem[];
}

CallDetails.displayName = 'CallDetails';

export default CallDetails;
